import { getAuth } from 'firebase/auth'
import bookingModal from '@/components/bookingModal'
import Heart from "@/components/heart";
import { format, startOfDay, parseISO } from 'date-fns'
// https://dbrekalo.github.io/vue-date-pick/examples.html#date-time-picker-am-pm
import DatePick from 'vue-date-pick';
import 'vue-date-pick/dist/vueDatePick.css';
import Multiselect from 'vue-multiselect'
import "vue-multiselect/dist/vue-multiselect.min.css";
var images = require.context("@/assets/", false, /\.svg$/);
import helpers from '@/helpers';
import { arrayRemove, arrayUnion, updateDoc, doc } from "firebase/firestore";
import { db } from "@/main";

export default {
  name: "reserve",
  components: {
    bookingModal,
    DatePick,
    Multiselect,
    Heart
  },
  props: [],
  data() {
    return {
      filter: {
        tags: null,
        string: null,
        group: null,
      },
      resourcesAvail: {
        unavailable: [],
        available: [],
        bookedByUser: [],
      },
      filteredResources: null,
      resourceToBook: null,
      selectedDate: null,
      lastResource: null,
      view: {
        bookingModal: false,
        points: false,
        displayButtons: true,
      },
      filterGroupData: null,
    };
  },
  computed: {
    resources () {
      return this.$store.getters.docFiles(this.filter, "resources")
    },
    resourceDirectory () {
      return this.$store.state.resources.boundDirectory;
    },
    user () {
      return this.$store.getters.userData;
    },
    org () {
      return this.$store.getters.activeOrg;
    },
    resourcesTags () {
      return this.$store.getters.resourcesTags;
    },
    dayBeginning () {
      return startOfDay(parseISO(this.selectedDate)).getTime();
    },
    groups () {
      return this.$store.state.groups.docs;
    },
    groupListNames () {
      // for populating the group filter
      let list = [];
      for (const res in this.groups) {
        let obj = {
          name: this.groups[res]["name"],
          id: this.groups[res]["id"],
        };
        list.push(obj);
      }
      return list;
    },
    favResources () {
      // gets list of all current resources, and returns those that are favourites
      return this.resources.filter(res => this.isFavourite(res))
    },
    filterGroupPoints () {
      // we need this so that when the user has a group filter that has a hotspot, and ALSO a tag filter, 
      // the dots on the floorplan need to ALSO be filtered. (otherwise they error when clicked)
      // so we should only return those resources that are also in the filtered resources that the store is filtering for us. 
      let returnArr = []
      if(!this.filterGroupData || !this.filterGroupData.hotspot || !this.filterGroupData.hotspot.points.length){
        return returnArr
      } 
      returnArr = this.filterGroupData.hotspot.points.filter(point => {
        // point.resource
        let exists = this.resources.find(obj => obj.id === point.resource)
        console.log('exists:', exists);
        
        return (exists ? true : false)
      })
      return returnArr
    }
  },
  watch: {
    resources() {
      // necesary as the buttons aren't showing sometimes on initial load
      this.handleResources();
    },
    $route() {
      // for handling when resourceModal is closed
      // console.log('this.$route now:', this.$route);

      const query = Object.assign({}, this.$route.query);
      if (!query.show && this.view.bookingModal) {
        this.closeBookingModal();
      }

      if (query.show && !this.view.bookingModal) {
        this.bookResource(this.resourceDirectory[query.show]);
      }
    },
    selectedDate() {
      // console.log('date changed: ', this.selectedDate)
      if (this.$route.query.date !== this.selectedDate) {
        this.$router.push({ query: { date: this.selectedDate } });
      }

      this.handleResources();
    },
    async groupListNames() {
      // if there's a url query, use it
      // this will likely only happen just after component is mounted
      let matchedGroup = this.groupListNames.find(
        (obj) => obj.id == [this.$route.query.group]
      );
      console.log("matchedGroup:", matchedGroup);

      if (matchedGroup) {
        this.filter.group = matchedGroup;
        let data = this.groups.find(gr => gr.id === this.filter.group.id)
        if (!data.loadedData) {
          data = await this.$store.dispatch("fetchDocData", {
            id: this.filter.group.id,
            collection: "groups",
          });
        }
        this.filterGroupData = data;
        this.watchforFloorplanImage();
      }
    },
  },
  mounted() {
    if (this.$route.query.date) {
      this.selectedDate = format(
        new Date(this.$route.query.date),
        "yyyy-MM-dd"
      );
    } else {
      this.selectedDate = format(new Date(), "yyyy-MM-dd");
    }

    // handle tags
    if (this.$route.query.tags) {
      this.filter.tags = this.$route.query.tags.split(",") || null;
    }

    this.handleResources();

    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResources() {
      console.log('this.resources:', this.resources);
      
      // 3 arrays
      // available
      // bookedbyUser
      // unavailable
      // for every resource we have data for
      // put its ID in the appropriate array
      this.resourcesAvail.unavailable = [];
      this.resourcesAvail.available = [];
      this.resourcesAvail.bookedByUser = [];
      this.view.displayButtons = false;

      this.resources.forEach((res) => {
        if (res.reservations && res.reservations.onceOff) {
          let avail = this.getAvail(res);
          // console.log('avail:', avail);
          this.resourcesAvail[avail].push(res.id);
        }
      });
      this.view.displayButtons = true;
    },
    handleResize() {
      // Explanation
      // https://www.youtube.com/watch?v=nn2FB1P_Mn8
      this.view.points = false;
      this.view.points = true;
    },
    // async processResources () {
    //   // console.log("processing resources")
    //   for(let i in this.resources) {
    //     this.processResource(this.resources[i])
    //   }
    // },
    getAvail(resource) {
      // returns state of booking for this resource for the UI
      // console.log('checking status for:', resource.id)
      // console.log('resource:', resource);

      let status = "available";

      resource.reservations.onceOff.forEach((res) => {
        if (res.startTime === this.dayBeginning) {
          // resource is booked for this day
          resource.booked = true;
          status = "unavailable";

          // check if user owns the relevant reservation
          if (res.guestUid == this.user.id) {
            resource.bookedByUser = true;
            status = "bookedByUser";
          }
        }
      });

      return status;
    },
    async cancelReservation(resource) {
      console.log("cancelling reservation for resource:", resource);

      resource.state = "cancelling";

      const auth = getAuth();
      const user = auth.currentUser;
      let token = await user.getIdToken(user, true);

      // find the reservation we wanna cancel
      let reservation = resource.reservations.onceOff.filter((res) => {
        return res.startTime === this.dayBeginning;
      })[0];

      if (!reservation) {
        console.log("NO RESERVATION FOUND");
        this.$toast.error("Error, no reservation found... :/");
        return;
      }

      let obj = {
        token: token,
        org: this.org.id,
        resource: resource.id,
        reservationId: reservation.id,
        email: this.user.email,
        uid: this.user.id,
      };

      console.log("obj to post:", obj);

      try {
        let res = await fetch("/api/cancelreservation", {
          method: "post",
          body: JSON.stringify(obj),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });

        res = await res.json();
        console.log("res:", res);

        if (!res.error) {
          // let store handle updating the resource with forceRefresh true
          this.$store.dispatch("updateDoc", {
            data: new helpers.Resource(res.data),
            action: "update",
            docType: "resources",
            fullDoc: true
          });

          this.$toast.success(`${this.$t('toast-Cancelled')} ${resource.name}`);
        } else {
          throw res.message;
        }
      } catch (error) {
        console.log("error cancelling reservation:", error);
        this.$toast.error(`${this.$t('toast-Error')}` + error);
      } finally {
        // fetch the newest data from DB - necessary for error AND success
        resource.state = null;
        this.handleResources();
      }
    },
    isPastDate(date) {
      // takes in a date of the calendar, and determines if it's past or future
      // used to disable certain dates in the calendar
      return date.getTime() < startOfDay(new Date()).getTime();
    },
    bookResource(resource) {
      console.log("open booking modal for resource:", resource);

      this.resourceToBook = resource;
      this.view.bookingModal = true;

      // update URL so back button works properly
      const query = Object.assign({}, this.$route.query);
      if (!query.show) {
        query.show = resource.id;
        this.$router.push({ query });
      }
    },
    async groupFilterInput() {
      // update query params, filter results appropriately
      const query = Object.assign({}, this.$route.query);

      // query.group = this.filter.group.join(",")
      console.log("group filter changed, now:", this.filter.group);

      if (this.filter.group) {
        query.group = this.filter.group.id;

        console.log('this.groups:', this.groups);
        
        let data = this.groups.find(el => el.id === this.filter.group.id);
        console.log('data:', data);
        
        if (!data.loadedData) {
          data = await this.$store.dispatch("fetchDocData", {
            id: this.filter.group.id,
            collection: "groups",
          });
        }
        this.filterGroupData = data;
        console.log("this.filter.group:", this.filter.group);

        if (this.filterGroupData.hotspot) {
          this.watchforFloorplanImage();
        } else {
          this.filterGroupData = null;
          this.view.points = false;
        }
      } else {
        delete query.group;
        this.filterGroupData = null;
        this.view.points = false;
      }
      this.$router.push({ query });
    },
    tagSearchInput() {
      console.log("tag search changed, now:", this.filter.tags);
      // filter resourceDirectory for resources that contain the tags in the input

      // update tags in query param
      const query = Object.assign({}, this.$route.query);

      query.tags = this.filter.tags.join(",");

      if (!this.filter.tags.length) {
        delete query.tags;
        this.filter.tags = null;
      }

      console.log("query:", query);

      this.$router.push({ query });
    },
    async visibilityChanged(isVisible, entry, resource) {
      if (isVisible && !resource.loadedData) {
        console.log("we need to fetch:", resource);
        let storeResource = this.$store.getters.resource(resource.id);

        if (!storeResource || !storeResource.loadedData) {
          resource = await this.$store.dispatch("fetchDocData", {
            id: resource.id,
            collection: "resources",
          });
          // storeResource = await this.processResource(resource)
        }

        this.$set(resource, storeResource);
      }
    },
    async closeBookingModal(booked) {
      console.log("closing booking modal");
      if (booked) {
        // only refresh data if we need to...
        // await this.refreshResource(this.resourceToBook);
        this.handleResources();
      }

      this.view.bookingModal = false;
      this.resourceToBook = null;

      const query = Object.assign({}, this.$route.query);
      if (query.show) {
        delete query.show;
        this.$router.push({ query });
      }

      this.$forceUpdate();
    },
    async watchforFloorplanImage() {
      console.log("watchign floorplanimage");
      let haveWidthAndHeight = false;
      while (!haveWidthAndHeight) {
        await helpers.wait(500);
        console.log("this.$refs.floorplan:", this.$refs.floorplan);

        if (!this.$refs.floorplan) {
          return;
        }

        let height = this.$refs.floorplan.$el.offsetHeight;
        let width = this.$refs.floorplan.$el.offsetWidth;

        if (height && width) {
          this.view.points = true;
          haveWidthAndHeight = true;
        }
      }
    },
    inlinePointStyle(point) {
      // returns inline styles for the floorplan
      // locating the dots in the appropriate places on the image
      // based on the image's width
      // console.log("generating styles for point:", point)

      let height = this.$refs.floorplan.$el.offsetHeight;
      let width = this.$refs.floorplan.$el.offsetWidth;

      let style = {
        top: height * point.y + "px",
        left: width * point.x + "px",
        width: width * 0.04 + "px", // adjust width and height based on image size
        height: height * 0.04 + "px",
      };
      // console.log('style:', style);

      return style;
    },
    hotspotIcon(point) {
      return point.resource
        ? images("./dot-assigned.svg")
        : images("./dot-unassigned.svg");
    },
    pointTooltip(point) {
      let text = "";
      if (this.resourceDirectory[point.resource]) {
        text += this.resourceDirectory[point.resource]["name"];
      } else {
        text += this.$t("floorplans-Unassigned");
      }
      text += "<br>" + this.$t("floorplans-Click-to-view");
      return text;
    },
    dotClicked(point, index) {
      console.log("point clicked:", point);

      console.log('this.resources:', this.resources);
      
      let resource = this.resources.find((res) => res.id == point.resource);

      console.log("resource:", resource);

      this.bookResource(resource);
    },
    isFavourite(resource){
      
      if (
        this.user.orgs &&
        this.user.orgs[this.org.id] &&
        this.user.orgs[this.org.id]["favs"]
      ) {
        if (this.user.orgs[this.org.id]["favs"].includes(resource.id))
          return true;
      }
      return false
    },
    async toggleFavourite(resource) {
      console.log('toggling resource favourite')
      // update the user document to append this resource ID to the favourites list if it's not in it. 
      // if it's already there, remove it.

      if(this.user.orgs[this.org.id]['favs'].includes(resource.id)){
        // remove favourite
        try {
          await updateDoc(doc(db, "users", this.user.id), {
            [`orgs.${this.org.id}.favs`]: arrayRemove(resource.id),
          });

          this.$toast.success(this.$t("toast-Removed-from-favourites"));

        } catch (error) {
          console.log("error removing resource from favs:", error)
          console.log(`error data: resource: ${resource.id} in org ${this.org.id} for user ${this.user.id}`)
          this.$toast.error(`Error: ${error}`)
        }
      } else {
        // add favourite
        // users will have an orgs obj, with org IDs on it, and in there, objects of settings for that org
        try {
          await updateDoc(doc(db, "users", this.user.id), {
            [`orgs.${this.org.id}.favs`]: arrayUnion(resource.id),
          });
          console.log("user favs saved")
          this.$toast.success(this.$t("toast-Added-to-favourites"));
          console.log("this.user now:", this.user);
        } catch (error) {
          console.log("error saving user favs:", error)
          this.$toast.error(`Error: ${error}`)
        }
      }
    }
  },
};